import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { ActivityReservation } from './activity-reservation';
import { retry } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { SharedService } from '../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class ActivityReservationService {

	paymentStatuses: any = [
		{ value: 'unpaid',   name: 'Unpaid' },
		{ value: 'partial',  name: 'Partial' },
		{ value: 'paid',     name: 'Paid in Full' },
		{ value: 'refunded', name: 'Refunded' },
	];

	bookingStatuses: any = [
		{ value: 'pending',   name: 'Pending' },
		{ value: 'confirmed', name: 'Confirmed' },
		{ value: 'completed', name: 'Completed' },
		{ value: 'cancelled', name: 'Cancelled' },
	];

	timeSlots: any = [
		{ value: '6:00 AM',  name: '6:00 AM' },
		{ value: '7:00 AM',  name: '7:00 AM' },
		{ value: '8:00 AM',  name: '8:00 AM' },
		{ value: '9:00 AM',  name: '9:00 AM' },
		{ value: '10:00 AM', name: '10:00 AM' },
		{ value: '11:00 AM', name: '11:00 AM' },
		{ value: '12:00 PM', name: '12:00 PM' },
		{ value: '1:00 PM',  name: '1:00 PM' },
		{ value: '2:00 PM',  name: '2:00 PM' },
		{ value: '3:00 PM',  name: '3:00 PM' },
		{ value: '4:00 PM',  name: '4:00 PM' },
		{ value: '5:00 PM',  name: '5:00 PM' },
		{ value: '6:00 PM',  name: '6:00 PM' },
		{ value: '7:00 PM',  name: '7:00 PM' },
	];

	constructor(
		private http: HttpClient,
		private sharedService: SharedService,
	) { }

	urlEndpoint = 'activity-reservations';

	add(reservation: ActivityReservation): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, reservation);
	}

	update(reservation: ActivityReservation): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, reservation);
	}

	delete(id: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta: any, globalFilter: any, filters: any): Observable<ApiResponse> {
		const params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params }).pipe(retry({ count: 2, delay: 1500 }));
	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}
}
